import { Hash } from "viem";

import { postReferralCodesOwners } from "lib/apis/referral";
import { decodeReferralCode } from "sdk/utils/referrals";

import type { CodeOwnershipInfo } from "../types";

export async function getCodeOwnersData(
  chainId: number,
  account: string | null | undefined,
  codes: string[] = []
): Promise<CodeOwnershipInfo[] | undefined> {
  if (codes.length === 0 || !account || !chainId) {
    return undefined;
  }
  try {
    const response = await postReferralCodesOwners({ chainId, codes });
    const codeOwners = response.items.reduce(
      (acc, cv) => {
        acc[cv.code] = cv.owner;
        return acc;
      },
      {} as Record<string, string | undefined>
    );

    return codes.map((code) => {
      const owner = codeOwners[code];
      return {
        code,
        codeString: decodeReferralCode(code as Hash),
        owner,
        isTaken: Boolean(owner),
        isTakenByCurrentUser: Boolean(owner && owner.toLowerCase() === account.toLowerCase()),
      };
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Error fetching referral code owners for chain ${chainId}:`, error);
    return undefined;
  }
}
